export enum DataActions {
	ON_LOAD_DATA = "ON_LOAD_DATA",
	ON_LOAD_DATA_DONE = "ON_LOAD_DATA_DONE",

}

export enum UserActions {

}

export enum MessageAction {
	SHOW_MESSAGE = "SHOW_MESSAGE",
	HIDE_MESSAGE = "HIDE_MESSAGE",
	SHOW_ERROR = "SHOW_ERROR",
	HIDE_ERROR = "HIDE_ERROR",
}
